module.exports = __webpack_public_path__ + "static/media/kobblest._holland.321acfaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/kobblest._holland.jpg
// module id = 453
// module chunks = 0